module.exports = __webpack_public_path__ + "img/qq.762ef26a.svg";